export const SET_OUTLETS = 'SET_OUTLETS'
export const SET_CURRENT_OUTLET = 'CURRENT_OUTLET'
export const GET_CURRENT_OUTLET_REQUEST = 'GET_CURRENT_OUTLET_REQUEST'
export const OUTLETS_REQUEST = 'OUTLET_REQUEST'



// WEBPACK FOOTER //
// ./app/actions/outlet/constants.js